import React, { Fragment, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import CustomLoader from 'src/components/CustomLoader/CustomLoader';
import Header from 'src/components/Header/Header';
import { usePostListingById } from 'src/hooks/usePostListing';
import postFailSvg from 'src/images/posted-fail.svg';
import postSuccessSvg from 'src/images/posted-success.svg';

import Confirmation from './components/Confirmation';

const PostListing = () => {
  const { id: listingId } = useParams();
  const postListing = usePostListingById();

  useEffect(() => {
    if (typeof listingId === 'string' && postListing.status.kind === 'idle') {
      postListing.post(listingId);
    }
  }, [listingId, postListing]);

  const params =
    postListing.status.kind === 'success'
      ? {
          title: 'Congratulations',
          cardTitle: 'You have successfully posted your business for sale',
          body: 'Call customer service on 13 73 35 (Mon - Fri, 9am - 5pm AEST) if we can help you with anything else.',
          icon: postSuccessSvg,
        }
      : {
          title: 'Something went wrong',
          cardTitle: 'Your business for sale has not been posted',
          body: 'Contact customer service on 13 73 35 (Mon - Fri, 9am - 5pm AEST) for help.',
          icon: postFailSvg,
        };

  return (
    <Fragment>
      <Header title="Sell your business" />
      {postListing.status.kind === 'loading' ? (
        <CustomLoader />
      ) : (
        <Confirmation {...params} />
      )}
    </Fragment>
  );
};

export default PostListing;
